import pick from 'lodash/pick';
import cloneDeep from 'lodash/cloneDeep';

const DEFAULT_TYPES = ['street_address'];

const ADDRESS_ITEMS = [
  'addressComponents',
  'formattedAddress',
  'geometry',
  'types',
  'placeId',
  'partialMatch',
  'addressComplement'
];

const ADDRESS_COMPONENTS_ITEMS = ['types', 'shortName', 'longName'];

export function getAddressData(address) {
  let addressData = cloneDeep(address);
  addressData = pick(addressData, ADDRESS_ITEMS);

  if (addressData.addressComponents) {
    const addressComponents = addressData.addressComponents;
    addressData.addressComponents = addressComponents.map(item => {
      return pick(item, ADDRESS_COMPONENTS_ITEMS);
    });
  }

  if (!addressData.types) {
    addressData.types = DEFAULT_TYPES;
  }

  return addressData;
}

export default function normalizeAddressData(addressData = {}) {
  if (addressData) {
    /* eslint-disable no-use-before-define */
    const { geometry, ...data } = addressData;
    /* eslint-enable no-use-before-define */

    if (!geometry || !data) {
      return null;
    }

    const {
      location: { lat, lng }
    } = geometry;
    const necessaryData = getAddressData(data);

    const parsedGeometry = {
      location: {
        lat: typeof lat === 'function' ? lat() : lat,
        lng: typeof lng === 'function' ? lng() : lng
      },
      viewport: {
        northeast: { lat: 1, lng: 2 },
        southwest: { lat: 1, lng: 2 },
        east: 0,
        south: 0,
        west: 0,
        north: 0
      },
      bounds: {
        east: 0,
        south: 0,
        west: 0,
        north: 0
      }
    };

    return {
      geometry: parsedGeometry,
      ...necessaryData
    };
  }

  return null;
}
